const url = '/visas';
const Provider = 'Visas';
const dbModel = 'Visas';

export { url, Provider, dbModel };
